import script from "./Slider.vue?vue&type=script&setup=true&lang=ts"
export * from "./Slider.vue?vue&type=script&setup=true&lang=ts"

import "./Slider.vue?vue&type=style&index=0&id=0fe53d08&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0fe53d08"]])

export default __exports__